import moment from 'moment'

import formReducer from './formsReducer'


const defaultDates = () => {
  const now = moment()
  const before = moment().subtract(1, 'months')

  return [before, now]
}

const initialState = {
  daterange: defaultDates(),
}

const formName = 'reportDownload'

export default formReducer(formName, initialState)
